<template>
    <div class="mainWrapper">


        <EmployeeSOPMainSideBar v-if="windowWidth > mobileWidthThreshold" />

        <div v-else>

            <EmployeeMobileTopNav />

            <EmployeeMobileSOPBottomNav />

        </div>





        <div class="rightContentWrapper"
            :style="windowWidth <= mobileWidthThreshold ? 'width: 100%; padding-top: 40px;' : ''">


            <div class="topNav">
                <TopBarVue v-if="windowWidth > mobileWidthThreshold" />
            </div>


            <div class="innerContainer">

                <div class="theHeaderWrapper">
                    <div>SOP Documents</div>


                </div>

                <!-- <div class="searchBarWrapper">
                    <input type="text" class="form-control theBar" placeholder="Search..." />
                </div> -->




                <div class="tableWrapper">



                    <router-link class="rowWrapper" v-for="(file, index) in employeeDashStore.sopFiles" :key="index" :to="{
                        name: 'EmployeeViewADocumentLive',
                        params: { uuid: file.uuid }
                    }">

                   


                        <div style="width: 90%;">

                            <div class="talkTitle">

                                {{ employeeDashStore.limitText(file.file_name) }}

                            </div>

                            <div class="bottomPart">

                                <div class="signedPart">


                                    PDF

                                </div>

                                <div class="datePart">


                                    

                                </div>




                            </div>


                        </div>

                        <div class="iconWrapper" style="width: 10%;">

                            <i class="bi bi-chevron-right" style="font-size: 20px; font-weight: bolder;"></i>

                        </div>

                    </router-link>




                </div>




            </div>






        </div>





    </div>
</template>

<script setup>

import { ref, onMounted, onUnmounted } from 'vue';
import EmployeeSOPMainSideBar from '@/components/EmployeeSOPMainSideBar.vue';
import TopBarVue from "@/components/TopBar.vue";
import EmployeeMobileSOPBottomNav from '@/components/EmployeeMobileSOPBottomNav.vue';
import EmployeeMobileTopNav from '@/components/EmployeeMobileTopNav.vue';
import { useEmployeeDashboardStore } from '@/stores/EmployeeDashboardStore';

const employeeDashStore = useEmployeeDashboardStore();

const windowWidth = ref(window.innerWidth);
const mobileWidthThreshold = 1230; // Example threshold for mobile width, adjust as needed


const onResize = () => {
    windowWidth.value = window.innerWidth;
};






onMounted(() => { 
    window.addEventListener('resize', onResize);

    employeeDashStore.fetchAllSOPFilesForEmployee() 

});

onUnmounted(() => {
    window.removeEventListener('resize', onResize);
});



</script>

<style  scoped>
.mainWrapper {
    /* background-color: rgb(118, 183, 240); */
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.rightContentWrapper {
    width: 83%;
    display: flex;
    flex-direction: column;
    /* background-color: bisque; */
}

.innerContainer {
    /* margin-top: 200px; */
    /* background-color: blueviolet; */
    overflow-y: auto;
    padding-top: 50px;
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 100px;
}

.theHeaderWrapper {
    display: flex;
    justify-content: space-between;
    text-align: left;
    font-size: 20px;
    font-weight: bold;
    /* background-color: aqua; */
}

.searchBarWrapper {
    margin-top: 15px;
    width: 100%;
    padding-bottom: 20px;
    /* background-color: rgb(22, 166, 37); */
}


.theBar {
    max-width: 350px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    border-radius: 10px;
}

.tableWrapper {
    margin-top: 20px;
    /* background-color: aqua; */
    width: 100%;
}

.my-custom-table tbody tr td {
    padding-top: 20px;
    /* Adjust the value as needed */
    padding-bottom: 20px;
    /* Adjust the value as needed */
}

.my-custom-table th {
    padding-bottom: 20px;
}

.my-custom-table th,
.my-custom-table td {
    text-align: left;
    /* Aligns text to the left */
    padding-left: 20px;
    padding-right: 20px;
}


.rowWrapper {
    display: flex;
    flex-direction: row;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    /* background-color: bisque; */
    /* box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; */
    width: 100%;
    border-radius: 10px;
    margin-bottom: 20px;
    padding: 20px;
    cursor: pointer;
    text-decoration: none;
    color: initial;
}

.rowWrapper:hover {
    background-color: rgb(243, 245, 244);
}

.talkTitle {
    /* background-color: antiquewhite; */
    text-align: left;
    font-weight: bold;
    overflow-wrap: break-word; /* Allows unbreakable words to be broken */
    word-wrap: break-word; /* Older syntax for overflow-wrap */
    word-break: break-word; /* Ensures that long words do not overflow */
    hyphens: auto; /* Automatically add hyphens when breaking words */
    
}

.bottomPart {
    display: flex;
    flex-direction: row;
    /* justify-content: space-between; */
    width: 100%;
    /* background-color: rgb(215, 215, 230); */
    margin-top: 10px;
}

.iconWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}


.signedPart {
    /* background-color: antiquewhite; */
    font-size: 13px;
    text-align: left;
    margin-right: 20px;
}

.datePart {
    /* background-color: antiquewhite; */
    font-size: 13px;
    text-align: left;
}
</style>